import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';
import { Route, RouteComponentProps, RouteProps } from 'react-router-dom';

import NotFound from '../../app/layout/NotFound';
import { RootStoreContext } from '../../app/stores/rootStore';

interface IProps extends RouteProps {
  component: React.ComponentType<RouteComponentProps<any>>;
}

const BmsgAuthCompleteRoute: React.FC<IProps> = ({ component: Component, ...rest }) => {
  const rootStore = useContext(RootStoreContext);
  const { isLogInBmsgAuth } = rootStore.memberStore;
  return <Route {...rest} render={(props) => (isLogInBmsgAuth ? <Component {...props} /> : <NotFound />)} />;
};

export default observer(BmsgAuthCompleteRoute);
